function addDays(date, days) {
    var newDate = new Date(date);
    newDate.setDate(date.getDate() + days);
    return newDate;
}

function addYears(date, years) {
    var newDate = new Date(date);
    newDate.setFullYear(date.getFullYear() + years);
    return newDate;
}

function addMonths(date, count) {

    if (date && count) {
        var m, d = (date = new Date(+date)).getDate();

        date.setMonth(date.getMonth() + count, 1);
        m = date.getMonth();
        date.setDate(d);

        if (date.getMonth() !== m)
            date.setDate(0);
    }

    return date;
}

function getDateWithoutTime (date) {
    return new Date(date.toDateString());
}

function getFirstDayOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
}

function getLastDayOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

function isSameYearAndMonth(date1, date2) {
    return date1.getMonth() === date2.getMonth() && date1.getYear() === date2.getYear();
}

function isSameDate(date1, date2) {
    return date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate();
}

export { addDays, addYears, addMonths, getDateWithoutTime, getFirstDayOfMonth, getLastDayOfMonth, isSameYearAndMonth, isSameDate };